export interface ServerError {
  code: number;
  message: string;
}

export enum ServerErrorMessage {
  E_MISSING_AUTHORIZATION = 'E_MISSING_AUTHORIZATION',
  E_EXPIRED_TOKEN = 'E_EXPIRED_TOKEN',
}
